// Reducer
import { ACTION_TYPES } from './subscription-actions';
import { SubscriptionState, initialState } from './subscription-state';

export default (state: SubscriptionState = initialState, action): SubscriptionState => {
  switch (action.type) {
    case ACTION_TYPES.SET_SUBSCRIPTION:
      return {
        ...state,
        subscriptionNumber: action?.payload?.subscriptionNumber,
        legalEndDateReflection: action?.payload?.legalEndDateReflection,
        offers: action?.payload?.offers,
        loading: false,
        signTxnCompletedAt: action?.payload?.signTxnCompletedAt,
        signTxnUrl: action?.payload?.signTxnUrl,
        signTxnId: action?.payload?.signTxnId,
        status: action?.payload?.status,
        externalRef: action?.payload?.externalRef,
        paymentMethod: action?.payload?.paymentMethod,
        subscriber: action?.payload?.subscriber
      };

    case ACTION_TYPES.SET_INITIALIZE_SUBSCRIPTION:
      return {
        ...state,
        offers: action?.payload?.offers,
        loading: false
      };
    case ACTION_TYPES.SET_SHORT_OFFER_CODE:
      return {
        ...state,
        shortOfferCode: action?.payload?.shortOfferCode
      };
    case ACTION_TYPES.INIT_CREATE_PENDING_SUBSCRIPTION:
      return {
        ...state,
        createInProgress: true
      };
    case ACTION_TYPES.RESET_CREATE_PENDING_SUBSCRIPTION:
      return {
        ...state,
        createInProgress: false
      };
    case ACTION_TYPES.CREATE_PENDING_SUBSCRIPTION:
      return {
        ...state,
        createInProgress: false,
        subscriptionNumber: action?.payload?.subscriptionNumber
      };
    case ACTION_TYPES.SET_ERROR: {
      return {
        ...state,
        errorMessage: action.payload
      };
    }
    case ACTION_TYPES.SET_SIGN_ERROR: {
      return {
        ...state,
        errorSignMessage: action.payload
      };
    }
    case ACTION_TYPES.RESET_ERROR: {
      return {
        ...state,
        errorMessage: ''
      };
    }
    case ACTION_TYPES.RESET_SIGN_ERROR: {
      return {
        ...state,
        errorSignMessage: ''
      };
    }
    case ACTION_TYPES.SET_SOURCE: {
      return {
        ...state,
        source: action.payload
      };
    }

    case ACTION_TYPES.SET_DOCUMENTS_SIGNED: {
      return {
        ...state,
        documentsSigned: [...action.payload]
      };
    }
    default:
      return state;
  }
};
